import { render, staticRenderFns } from "./MasterProducts.vue?vue&type=template&id=1ef61ed8&scoped=true"
import script from "./MasterProducts.vue?vue&type=script&lang=js"
export * from "./MasterProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef61ed8",
  null
  
)

export default component.exports